import React, { useState, useEffect } from "react";
import { Filter } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Archive, Box, Calendar, User, Edit, Trash2 } from "react-feather";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Table from "../../core/pagination/datatable";
import StockadjustmentModal from "../../core/modals/stocks/stockadjustmentModal";
import { useDispatch, useSelector } from "react-redux";
import Axios from "axios";
import { API_BASE_URL, GET_VSTORE_PROD } from "../../Config";
import { setstockadjustment_data } from "../../core/redux/action";
import useOnlineStatus from '../../userOnlineStatus';
import OnlineImg from '../inventory/online.jpg';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getUserPermissions } from "../../UserPermissions";
import ProductExcels from "../inventory/productexcels";
import { Download } from "react-feather";
import SpinLoader from "../loader/SpinLoader";



const StockAdjustment = () => {

  const isOnline = useOnlineStatus();
  const [userDataSession, setUserDataSession] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();
  const dataSource = useSelector((state) => state.stockadjustment_data) || [];
  const [searchQuery, setSearchQuery] = useState("");


  // #region Session userdetails
  useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserDataSession(userData);
      } else {
        console.log("User data not found in sessionStorage");
        navigate('/');
      }
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);

      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        IsActive: 1,
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            dispatch(setstockadjustment_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const [permissions, setPermissions] = useState({
    isRead: 'd-none',
    isWrite: 'd-none',
    isDelete: 'd-none',
    isExport: 'd-none'
  });

  useEffect(() => {
    const perms = getUserPermissions("Adjustment");
    setPermissions(perms);
  }, []);

  const data = useSelector((state) => state.stockadjustment_data);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const warehouseOptions = [
    { value: "Choose Warehouse", label: "Choose Warehouse" },
    { value: "Lobar Handy", label: "Lobar Handy" },
    { value: "Quaint Warehouse", label: "Quaint Warehouse" },
    { value: "Traditional Warehouse", label: "Traditional Warehouse" },
    { value: "Cool Warehouse", label: "Cool Warehouse" },
  ];

  const productOptions = [
    { value: "Choose Product", label: "Choose Product" },
    { value: "Nike Jordan", label: "Nike Jordan" },
    { value: "Apple Series 5 Watch", label: "Apple Series 5 Watch" },
    { value: "Amazon Echo Dot", label: "Amazon Echo Dot" },
    { value: "Lobar Handy", label: "Lobar Handy" },
  ];

  const personOptions = [
    { value: "Choose Person", label: "Choose Person" },
    { value: "Steven", label: "Steven" },
    { value: "Gravely", label: "Gravely" },
  ];

  const columns = [
    {
      title: "Product Name",
      dataIndex: "ProductName",
      sorter: (a, b) => a.ProductName.length - b.ProductName.length,
      render: (text) => text || "N/A", 
    },
    {
      title: "BarCode",
      dataIndex: "BarCode",
      sorter: (a, b) => a.BarCode.length - b.BarCode.length,
      render: (text) => text || "N/A", 
    },
    
    {
      title: "SKU",
      dataIndex: "ProductSKU",
      sorter: (a, b) => a.Email.ProductSKU - b.ProductSKU.length,
      render: (text) => text || "N/A", 
    },

    {
      title: "All Stock",
      dataIndex: "StockByUsers",
      sorter: (a, b) => a.StockByUsers.length - b.StockByUsers.length,
      render: (text) => {
        const formattedText = parseFloat(text).toFixed(2);
        return formattedText || "N/A";
      },
    },    

    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightEditStockAdj"
              aria-controls="offcanvasRightEditStockAdj"
              onClick={() => handleEditClick(record.Id)}
            >
              <Edit className="feather-edit" />
            </Link>

            <Link
              className="confirm-text p-2 d-none"
              to="#"
              onClick={showConfirmationAlert}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </td>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const handleEditClick = (id) => {
    setSelectedId(id);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  
  const handleDownloadExcel = () => {
    if (data.length === 0) {
        return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource && dataSource?.map((item) => ({
        'Product Name': item.ProductName,
        'BarCode': item.BarCode,
        'Category': item.CategoryName,
        'All STock': item.AllStock,
        'MRP': item.MRP,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'StockData');

    // Save the workbook to a file
    XLSX.writeFile(wb, 'StockData.xlsx');
  };

  const generatePDF = () => {
      const doc = new jsPDF();

      // Set properties for PDF
      doc.setProperties({
          title: 'Attendance Report',
          author: 'Your Name',
          creator: 'Your Application'
      });

      // Add data to PDF
      const tableData = []; // Your data array here

      // Add a header row
      const headers = ['Name', 'BarCode', 'Category', 'MRP', 'All Stock'];
      tableData.push(headers);

      // Add rows
      dataSource.forEach(item => {
          const row = [];
          row.push(item.ProductName, item.BarCode, item.CategoryName, item.MRP, item.AllStock);
          tableData.push(row);
      });

      // Generate table
      doc.autoTable({
          head: [headers],
          body: tableData.slice(1),
      });

      // Save the PDF
      doc.save('StockData.pdf');
  };

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.ProductName &&
        item.ProductName.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.BarCode &&
        item.BarCode.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.ProductSKU &&
        item.ProductSKU.toLowerCase().includes(searchQuery.toLowerCase()))
  );


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Stock Adjustment</h4>
                <h6>Manage your stock</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <div className="page-btn import">
                  <Link
                    to="#"
                    className={`btn btn-added color ${permissions.isRead}`}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                  >
                    <Download className="me-2" />
                    Update Products
                  </Link>
                </div>
              </li>
            </ul>
        </div>

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter disabled ${isFilterVisible ? "setclose" : ""}`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Archive className="info-img" />
                      <Select
                        className="select"
                        options={warehouseOptions}
                        placeholder="Choose Warehouse"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Box className="info-img" />
                      <Select
                        className="select"
                        options={productOptions}
                        placeholder="Choose Product"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Calendar className="info-img" />
                      <div className="input-groupicon">
                        <DatePicker
                          selected={selectedDate}
                          onChange={handleDateChange}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Choose Date"
                          className="datetimepicker"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        className="select"
                        options={personOptions}
                        placeholder="Choose Person"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              {!isOnline ? (
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <img src={OnlineImg} alt="offline-status" className="mb-3" style={{ height: '30rem' }} />
                    <p>You are offline. Please check your internet connection.</p>
                  </div>
                ) : loading ? (
                  // <div className="d-flex justify-content-center align-items-center">
                  //   <div className="loader"></div>
                  // </div>
                  
                  <SpinLoader/>
                ) : (
                  <Table columns={columns} dataSource={filteredData} />
                )}
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <StockadjustmentModal selectedId={selectedId} />
      <ProductExcels/>
    </div>
  );
};

export default StockAdjustment;
